import { Modalable, ResponseStatus } from './modalable';
import { QuickLinkType } from './quick-link';

export class DisabledFeatureModalable implements Modalable {
    static MODAL_ID = 'featureDisabledModal';

    type: QuickLinkType | string;
    iconUrl: string;

    status: ResponseStatus;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getModalId(): string {
        return DisabledFeatureModalable.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return false;
    }
}
